import { jsx as _jsx } from "react/jsx-runtime";
// Reduced-motion guard — gates animation calls based on user's OS preference.
import { createContext, useContext, useSyncExternalStore } from 'react';
/** Browser implementation — reads the real media query. */
export const browserReducedMotionSource = {
    subscribe(callback) {
        const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
        mql.addEventListener('change', callback);
        return () => mql.removeEventListener('change', callback);
    },
    getSnapshot() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
    getServerSnapshot() {
        return false;
    },
};
const MotionCtx = createContext({ motionEnabled: true });
/** Provider that tracks the user's reduced-motion preference. */
export function MotionProvider({ children, source = browserReducedMotionSource }) {
    const prefersReduced = useSyncExternalStore(source.subscribe, source.getSnapshot, source.getServerSnapshot);
    return (_jsx(MotionCtx, { value: { motionEnabled: !prefersReduced }, children: children }));
}
/** Returns whether motion is enabled. Use to gate animation calls. */
export function useMotion() {
    return useContext(MotionCtx).motionEnabled;
}
//# sourceMappingURL=MotionContext.js.map